import { render, staticRenderFns } from "./TechPreview.vue?vue&type=template&id=63e243b4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e243b4')) {
      api.createRecord('63e243b4', component.options)
    } else {
      api.reload('63e243b4', component.options)
    }
    module.hot.accept("./TechPreview.vue?vue&type=template&id=63e243b4&", function () {
      api.rerender('63e243b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/TechPreview.vue"
export default component.exports